import React from 'react';
import BalanceGridRow from '../types';
import { NavLink } from 'react-router-dom';

type Props = {
  data: BalanceGridRow;
};

const MemberRenderer = ({ data }: Props) => {
  return data?.memberId ? (
    <NavLink
      target="_blank"
      className="flex"
      key={data.memberId}
      to={`/members/${data.memberId}`}
    >
      {data?.memberLabel}
    </NavLink>
  ) : null;
};

export default MemberRenderer;
